import React from 'react'
import Slider from '../Components/Slider'
import '../Styles/partners.css'

function Partners() {
  return (
    <section id='partners-section' className='padding-50 flex-center background-dark text-white'>
      <h1 id='partner-title' className='subtitle-main'>Parceiros</h1>
      <Slider/>
    </section>
  )
}

export default Partners
